import { Controller } from '@hotwired/stimulus'

export default class RadioButtonVisibilityController extends Controller {
  static targets = ["toggleable", "toggler"];

  connect() {
    this.toggle();
  }

  toggle() {
    const isChecked = this.togglerTargets.some((radio) => radio.checked && radio.value === "true");

    if (isChecked) {
      this.toggleableTarget.classList.remove("d-none");
    } else {
      this.toggleableTarget.classList.add("d-none");
      this.#clearHiddenInputs();
    }
  }

  // private

  #clearHiddenInputs() {
    this.toggleableTarget.querySelectorAll("textarea").forEach((textarea) => {
      textarea.value = "";
    });
    this.toggleableTarget.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
      checkbox.checked = false;
    });
    this.toggleableTarget.querySelectorAll("input[type='radio']").forEach((radio) => {
      radio.checked = false;
    });
  }
}
